<template>
  <div>
    <v-alert type="error" v-if="reservation.canceled">Rezervace byla zrušena</v-alert>
    <v-tabs v-model="tab">
      <v-tab>
        Rychlý přehled
      </v-tab>
      <v-tab>
        Chat
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-container>
          <template
            v-if="!loading">
            <CardMiniatureHorizontalDemand
              :demand="reservation"
              :property-id="reservation.property.id"
              :room-id="reservation.room? reservation.room.id : null" />
            <DemandForm
              :demand="reservation"
              @edit-success="reload"
              :inputs-disabled="true"
            ></DemandForm>
          </template>
          <v-skeleton-loader
            v-else
            type="article"
          ></v-skeleton-loader>
        </v-container>
      </v-tab-item>
      <v-tab-item>
        tadz bude chat
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import DemandForm from '../../components/demands/DemandForm'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import CardMiniatureHorizontalDemand from '../../components/property/DemadPropertyCardMiniature'
export default {
  name: 'ReservationDetail',
  components: { CardMiniatureHorizontalDemand, DemandForm },
  data () {
    return {
      tab: 0
    }
  },
  created () {
    const url = this.isAdmin ? `/admin/reservations/${this.$route.params.id}` : `/reservations/${this.$route.params.id}`
    this.$http.get(url)
      .then(res => {
        if (!res.data.reservation) {
          let redirectName
          if (this.isAdmin) {
            redirectName = 'admin.demands.demand'
          } else {
            redirectName = 'host.demands.demand'
          }
          this.$router.replace({
            name: redirectName,
            params: {
              id: res.data.id
            }
          })
        }
        this.setReservation(res.data)
      })
      .catch(err => {
        if (err.response.status === 404) {
          this.setAlerts([{ message: 'Rezervace nenalezena', type: 'error' }])
        }
      })
  },
  computed: {
    loading () {
      return !Object.keys(this.reservation).length
    },
    ...mapGetters({
      reservation: 'detailViews/reservation',
      isAdmin: 'userAuth/isAdmin'
    })
  },
  methods: {
    reload () {
      location.reload()
    },
    ...mapMutations({
      setReservation: 'detailViews/setReservation'
    }),
    ...mapActions({
      setAlerts: 'alerts/setAlerts'
    })
  }
}
</script>

<style scoped>

</style>
